import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { HiDownload, HiEye, HiX } from 'react-icons/hi';
import { FaFilePdf } from 'react-icons/fa';
import './CV.css';

const CV_URL = '/sudip_majkoti_cv.pdf';

const CV = () => {
  const [previewOpen, setPreviewOpen] = useState(false);

  return (
    <section id="cv" className="cv">
      <div className="container">
        <div className="section-header">
          <span className="section-label">[ 07 // CURRICULUM VITAE ]</span>
          <h2 className="section-title">Resume &amp; CV</h2>
          <p className="section-subtitle">
            Review my complete professional profile, engineering achievements, and technical credentials.
          </p>
        </div>

        <motion.div
          className="cv__content"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4 }}
        >
          <div className="cv__preview-card">
            <div className="cv__header-bar">
              <div className="cv__header-file">
                <FaFilePdf className="cv__pdf-icon" />
                <span>sudip_majkoti_cv.pdf</span>
              </div>
              <span className="cv__header-badge">[ READY TO DOWNLOAD ]</span>
            </div>

            <div className="cv__embed-wrapper" onClick={() => setPreviewOpen(true)}>
              <iframe
                src={`${CV_URL}#toolbar=0&navpanes=0`}
                title="CV Preview"
                className="cv__embed"
              />
              <div className="cv__embed-overlay">
                <HiEye className="cv__overlay-icon" />
                <span>Click to Expand Fullscreen</span>
              </div>
            </div>

            <div className="cv__actions">
              <button
                className="btn btn-outline cv__action-btn"
                onClick={() => setPreviewOpen(true)}
              >
                <HiEye />
                <span>Preview Document</span>
              </button>
              <a
                href={CV_URL}
                download="Sudip_Majkoti_CV.pdf"
                className="btn btn-primary cv__action-btn"
              >
                <HiDownload />
                <span>Download CV (PDF)</span>
              </a>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Fullscreen preview modal */}
      {previewOpen && (
        <motion.div
          className="cv__modal"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={() => setPreviewOpen(false)}
        >
          <div className="cv__modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="cv__modal-header">
              <div className="cv__modal-title-row">
                <FaFilePdf className="cv__pdf-icon" />
                <h3>Sudip Majkoti &bull; Curriculum Vitae</h3>
              </div>
              <div className="cv__modal-actions">
                <a
                  href={CV_URL}
                  download="Sudip_Majkoti_CV.pdf"
                  className="btn btn-primary cv__btn--sm"
                >
                  <HiDownload />
                  <span>Download</span>
                </a>
                <button
                  className="cv__modal-close"
                  onClick={() => setPreviewOpen(false)}
                  aria-label="Close preview"
                >
                  <HiX />
                </button>
              </div>
            </div>
            <iframe
              src={CV_URL}
              title="CV Full Preview"
              className="cv__modal-iframe"
            />
          </div>
        </motion.div>
      )}
    </section>
  );
};

export default CV;
